import { gql } from '@apollo/client';

export const QUERY_GET_USER_TO_DEVICES = gql`
  query QUERY_GET_USER_TO_DEVICES(
    $userId: uuid!
  ) {
    userToDevices(where: {userId: {_eq: $userId}}) {
      created_at
      deviceId
      description
      doctorId
      id
      updated_at
      userId
    }
  }
`;

export const QUERY_GET_ALL_DEVICES = gql`
  query QUERY_GET_ALL_DEVICES {
    getSmartmeterDevicesWithMetadata {
      id
      metadata
    }
  }
`;

export const QUERY_GET_ALL_USER_TO_DEVICES = gql`
  query QUERY_GET_ALL_USER_TO_DEVICES {
    userToDevices {
      created_at
      deviceId
      description
      doctorId
      id
      updated_at
      userId
    }
  }
`;